import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { get } from '@/features/shared/lib/api';
import MypageMyProfileView from '@/features/mypage/components/MypageMyProfileView';
import MypageMyProfileEdit from '@/features/mypage/components/MypageMyProfileEdit';
import MypageProfileError from '@/features/mypage/components/MypageProfileError';

export default function MypageMyProfile() {
  const location = useLocation();
  const navigate = useNavigate();

  // 로그인 체크
  useEffect(() => {
    const isLoggedIn = typeof rmVars !== 'undefined' && rmVars?.isLogin;
    if (!isLoggedIn) {
      const homeUrl = (typeof rmVars !== 'undefined' && rmVars.homeUrl) ? rmVars.homeUrl : '';
      window.location.href = homeUrl + '/login/';
    }
  }, []);

  const [isEditMode, setIsEditMode] = useState(false);
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errorCode, setErrorCode] = useState(null);

  // URL 기반으로 edit 모드 확인
  useEffect(() => {
    if (location.pathname.includes('/mypage/edit/')) {
      setIsEditMode(true);
    } else {
      setIsEditMode(false);
    }
  }, [location.pathname]);

  // 데이터 불러오기 함수 (전체 응답 확인하여 error_code not_found 처리)
  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      setErrorCode(null);
      const res = await get('/rm/v1/my_library');
      if (res?.result?.error_code === 'not_found') {
        setRecord(null);
        setErrorCode('not_found');
        setError(res?.message || '연구자 정보를 찾을 수 없습니다.');
        return;
      }
      const rec = res?.record ?? res?.result?.record ?? null;
      setRecord(rec || null);
    } catch (e) {
      setError(e?.response?.data?.message || e.message);
      setErrorCode(e?.response?.data?.error_code || null);
    } finally {
      setLoading(false);
    }
  };

  // 초기 API 호출
  useEffect(() => {
    let mounted = true;
    const loadData = async () => {
      await fetchData();
    };
    loadData();
    return () => { mounted = false; };
  }, []);

  const handleEditClick = () => {
    navigate('/mypage/edit/profile');
    setIsEditMode(true);
  };

  const handleCancelClick = () => {
    navigate('/mypage');
    setIsEditMode(false);
  };

  if (!loading && error) {
    return <MypageProfileError errorCode={errorCode} error={error} />;
  }

  return (
    <>
      {isEditMode ? (
        <MypageMyProfileEdit onCancelClick={handleCancelClick} record={record} loading={loading} error={error} onUpdate={fetchData} />
      ) : (
        <MypageMyProfileView onEditClick={handleEditClick} record={record} loading={loading} error={error} />
      )}
    </>
  );
}
